import {onMounted, ref} from 'vue';
import apiClient from "../services/api";
import {User} from "../types/User";
import axios from 'axios';
import {isAuthenticated} from '../services/auth';

export function getCurrentUser() {
    const user = ref<User | null>(null);

    onMounted(async () => {
        if (!isAuthenticated()) {
            return;
        }

        try {
            const response = await apiClient.get('/me');
            user.value = response.data;
        } catch (error) {
            user.value = null;
            if (!axios.isAxiosError(error) || error.response?.status !== 401) {
                console.error('Error loading current user:', error);
            }
        }
    });

    return {user};
}
